import useOrgRoleStaffRoleTreeView from './UseOrgRoleStaffRoleTreeView';

import TreeView from '../TreeView';

import global from '../../GlobalStyle.module.css';

const OrgRoleStaffRoleTreeView = ({ label, name, value, error, message, onChange, roleGroupId,
  singleSelect = true, selectableLeavesOnly = true, excludeRegistrationRoles = false, excludeRegistrationRolesWithoutChildren = false
}) => {
  const { orgRoleStaffRoleHierarchyState, options } = useOrgRoleStaffRoleTreeView(roleGroupId, excludeRegistrationRoles, excludeRegistrationRolesWithoutChildren);

  return orgRoleStaffRoleHierarchyState.message
    ? <span className={global.LoadingMsg}>{orgRoleStaffRoleHierarchyState.message}</span>
    : (
      <TreeView
        label={label}
        name={name}
        value={value}
        error={error}
        message={message}
        options={options}
        singleSelect={singleSelect}
        selectableLeavesOnly={selectableLeavesOnly}
        isLoading={orgRoleStaffRoleHierarchyState.isArrayLoading}
        onChange={onChange} />
    );
};

export default OrgRoleStaffRoleTreeView;